export default {
  'menu.Ingreso': 'Ingreso',
  'menu.Inicio': 'Inicio',
  'menu.Tiendas': 'Tiendas',
  'menu.Personas': 'Personas',
  'menu.Usuarios': 'Usuarios',
  'menu.Segmentación': 'Segmentación',
  'menu.Segmentos por rol': 'Segmentos por rol',
};
